export default {
  title: 'Het aandelenkapitaal',
  description:
    'Wij raden je aan om voor minimaal 100 aandelen te kiezen. Daarnaast is het goed om wat geld in de holding te hebben bij de start. Zo kan je kiezen voor 100 aandelen met een nominale waarde van €1,-. Je moet dan bij oprichting €100,- storten op de bankrekening van de holding om de aandelen te volstorten.',
  number_of_shares: 'Aantal aandelen',
  shareholders: 'Aandeelhouder',
  warning:
    'Bij een hoog aandelenkapitaal moet de notaris extra werkzaamheden verrichten. Zo geldt er vanaf een aandelenkapitaal van €10.000 een wettelijke onderzoeksplicht voor de notaris naar de herkomst van het vermogen. Omdat dit maatwerk betreft is het via Ligo niet mogelijk om een B.V. op te richten met een aandelenkapitaal hoger dan €10.000. Voor meer informatie kun je met ons contact opnemen via 020-3031043.'
};
